<template>
  <div class="w-full p-4 box-border" v-loading="loading">
    <el-steps direction="vertical" space="auto" finish-status="process" class="ukp_procs_steps" :active="stepActive">
      <el-step>
        <template #title>
          <div
            class="w-full flex items-center justify-between select-none cursor-pointer"
            @click="step.process1 = !step.process1"
          >
            <p>确认结算单</p>
            <p
              :class="{
                flex: true,
                'items-center': true,
                'text-green-theme': alreadyConfirm || isConfirmPaid,
                'text-danger': noConfirm
              }"
              v-if="alreadyConfirm || noConfirm || isConfirmPaid"
            >
              <i class="el-icon-success font-medium mr-1"></i>
              <span class="text-small leading-none" v-if="alreadyConfirm || isConfirmPaid">已认可</span>
              <span class="text-small leading-none" v-else-if="noConfirm">不认可</span>
            </p>
          </div>
        </template>
        <el-collapse class="ukp_procs_coll" slot="description" accordion v-model="collVal.process1">
          <el-collapse-item name="process1">
            <div
              class="w-full px-2 py-1.5 mb-3 flex box-border overflow-hidden"
              :class="{
                'green-card': alreadyConfirm,
                'red-card': noConfirm
              }"
              v-if="!waitConfirm && (alreadyConfirm || noConfirm)"
            >
              <i class="el-icon-warning-outline text-small mt-0.5 mr-1"></i>
              <p class="flex-1 text-small leading-4">
                <span v-if="alreadyConfirm">您已确认结算单，请您与发布人线下协商打款事宜。</span>
                <span v-else-if="noConfirm">请与发布人沟通后，重新发起结算单确认。</span>
              </p>
            </div>
            <div class="w-full mb-5">
              <header class="mb-0.5 text-small text-theme-black-450 leading-22">结算项目名称：</header>
              <p class="w-full text-medium text-theme-black-850 leading-18">
                {{ detail.settleName }}
              </p>
            </div>
            <div class="w-full mb-5">
              <header class="mb-0.5 text-small text-theme-black-450 leading-22">结算总费用(元)：</header>
              <p class="text-medium text-theme-black-850 leading-18">
                {{ detail.operationalYuanAmount | formatPrice }}
              </p>
              <p class="w-full flex items-center leading-none" v-if="detail.adjustYuanAmount != 0">
                <span class="text-yellow-theme text-small leading-none">
                  含补扣款 {{ detail.adjustYuanAmount | formatPrice }}
                </span>
                <el-tooltip content="根据调查实际情况，给代理补扣相应款项，补扣款将计入代理结算总费用">
                  <i class="iconfont icon-shuoming text-small ml-0.5 mt-0.5 text-theme-black-350 cursor-pointer"></i>
                </el-tooltip>
              </p>
            </div>
            <div class="w-full mb-5" v-if="detail.adjustYuanAmount != 0">
              <header class="mb-0.5 text-small text-theme-black-450 leading-22">补扣款原因：</header>
              <p class="w-full text-medium text-theme-black-850 leading-18">
                {{ detail.adjustDescribe }}
              </p>
            </div>
            <!-- 单位的名称、账号、银行名称 -->
            <div class="text-yellow-theme mb-2 flex items-center" v-if="waitConfirm">
              <i class="el-icon-warning-outline text-medium mr-1"></i>
              <span class="text-small leading-22 whitespace-nowrap"> 如对结算费用无异议，请填写收款信息 </span>
            </div>
            <div class="w-full mb-5">
              <header class="mb-0.5 text-small text-theme-black-450 leading-22">收款单位名称：</header>
              <el-input class="w-full" placeholder="请输入" v-model="form.nameOfPayee" v-if="waitConfirm" />
              <p class="w-full text-medium text-theme-black-850 leading-18" v-else>
                {{ detail.nameOfPayee }}
              </p>
            </div>
            <div class="w-full mb-5">
              <header class="mb-0.5 text-small text-theme-black-450 leading-22">收款单位账号：</header>
              <el-input class="w-full" placeholder="请输入" v-model="form.accountOfPayee" v-if="waitConfirm" />
              <p class="w-full text-medium text-theme-black-850 leading-18" v-else>
                {{ detail.accountOfPayee }}
              </p>
            </div>
            <div class="w-full mb-5">
              <header class="mb-0.5 text-small text-theme-black-450 leading-22">收款单位开户银行名称：</header>
              <el-input class="w-full" placeholder="请输入" v-model="form.bankOfPayee" v-if="waitConfirm" />
              <p class="w-full text-medium text-theme-black-850 leading-18" v-else>
                {{ detail.bankOfPayee }}
              </p>
            </div>
            <div class="w-full flex items-center overflow-hidden" v-if="waitConfirm">
              <el-button
                type="primary"
                size="small"
                class="flex-2 px-2 mr-1.5"
                :loading="wReLoading"
                @click="whetherRecognized(true)"
              >
                认可并提交收款信息
              </el-button>
              <el-button
                type="primary"
                size="small"
                plain
                class="flex-1 px-2 ml-1.5"
                :loading="noReLoading"
                @click="whetherRecognized(false)"
              >
                不认可
              </el-button>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-step>
      <el-step>
        <template #title>
          <div
            class="w-full flex items-center justify-between select-none cursor-pointer"
            @click="step.process2 = !step.process2"
            v-if="isConfirmPaid"
          >
            <p>确认收款</p>
            <p class="flex items-center text-green-theme" v-if="alreadyConfirmPaid">
              <i class="el-icon-success font-medium mr-1"></i>
              <span class="text-small leading-none">已确认收款</span>
            </p>
          </div>
          <p class="w-full flex items-center justify-between" v-else>确认收款</p>
        </template>
        <el-collapse class="last_ukp_procs_coll" slot="description" accordion v-model="collVal.process2">
          <el-collapse-item name="process2">
            <div class="w-full mt-3" v-if="waitConfirmPaid">
              <p class="text-small text-theme-black-450 leading-4">发布人已操作对公转账。</p>
              <p class="text-small text-theme-black-450 leading-4">款项如已到账，请操作【我已收款】</p>
              <p class="text-small text-theme-black-450 leading-4">款项如未到账，请与发布人线下沟通确认</p>
              <el-button type="primary" size="small" class="w-full mt-3" :loading="rvLoading" @click="whetherConfirmReceivables"
                >我已收款</el-button
              >
            </div>
            <template v-else>
              <div class="w-full mt-3 mb-5">
                <header class="mb-0.5 text-small text-theme-black-450 leading-22">确认收款时间：</header>
                <p class="w-full text-medium text-theme-black-850 leading-18">
                  {{ detail.confirmPaidTime }}
                </p>
              </div>
              <div class="w-full mb-5">
                <header class="mb-0.5 text-small text-theme-black-450 leading-22">确认人：</header>
                <p class="w-full text-medium text-theme-black-850 leading-18">
                  {{ detail.confirmPaidUserBy }}
                </p>
              </div>
            </template>
          </el-collapse-item>
        </el-collapse>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import { filtersMixins } from '@/mixins/relate-settlement'
import { getSettlementDetail, confirmSettlement, confirmReceivables } from '@/api/cost-settlement/undertake'
import { csCode, undertakeStatusCode } from '../config/undertake'

export default {
  name: 'UndertakeProcess',
  mixins: [filtersMixins],
  props: {
    investSid: {
      type: [String, Number],
      default: ''
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      step: {
        process1: true,
        process2: false
      },
      form: {
        nameOfPayee: '',
        accountOfPayee: '',
        bankOfPayee: ''
      },
      loading: false,
      detail: {
        settleName: '—',
        operationalYuanAmount: 0,
        adjustYuanAmount: 0,
        adjustDescribe: '—',
        nameOfPayee: '—',
        accountOfPayee: '—',
        bankOfPayee: '—',
        settleObjType: '',
        auditStatus: '',
        status: '',
        confirmPaidTime: '—',
        confirmPaidUserBy: '—'
      },
      wReLoading: false,
      noReLoading: false,
      rvLoading: false
    }
  },
  computed: {
    collVal() {
      const coll = {}
      for (const key in this.step) {
        coll[key] = this.step[key] ? key : ''
      }
      return coll
    },
    waitConfirmPaid() {
      return csCode.WAITPAID === this.detail.status
    },
    alreadyConfirmPaid() {
      return csCode.ALREADYPAID === this.detail.status
    },
    isConfirmPaid() {
      return this.waitConfirmPaid || this.alreadyConfirmPaid
    },
    stepActive() {
      return this.isConfirmPaid ? 1 : 0
    },
    alreadyConfirm() {
      return undertakeStatusCode.APPROVED === this.detail.status
    },
    noConfirm() {
      return undertakeStatusCode.REJECT === this.detail.status
    },
    waitConfirm() {
      return undertakeStatusCode.CONFIRMING === this.detail.status
    }
  },
  watch: {
    isConfirmPaid: {
      handler(bool) {
        this.step.process2 = bool
      },
      immediate: true
    },
    refresh(bool) {
      if (bool) {
        this.getDetail()
      }
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      if (this.investSid !== '' && this.investSid !== undefined && this.investSid !== null) {
        this.loading = true
        getSettlementDetail(this.investSid)
          .then(res => {
            const {
              settleName,
              operationalYuanAmount,
              adjustYuanAmount,
              adjustDescribe,
              nameOfPayee,
              accountOfPayee,
              bankOfPayee,
              settleObjType,
              auditStatus,
              status,
              confirmPaidTime,
              confirmPaidUserBy
            } = res?.data?.data ?? {}
            this.detail.settleName = settleName ?? '—'
            this.detail.operationalYuanAmount = operationalYuanAmount ?? 0
            this.detail.adjustYuanAmount = adjustYuanAmount ?? 0
            this.detail.adjustDescribe = adjustDescribe ?? '—'
            this.detail.nameOfPayee = nameOfPayee ?? '—'
            this.detail.accountOfPayee = accountOfPayee ?? '—'
            this.detail.bankOfPayee = bankOfPayee ?? '—'
            this.detail.settleObjType = settleObjType ?? '—'
            this.detail.auditStatus = auditStatus ?? ''
            this.detail.status = status ?? ''
            this.detail.confirmPaidTime = confirmPaidTime ?? '—'
            this.detail.confirmPaidUserBy = confirmPaidUserBy ?? '—'
            // 有值就默认填写上
            this.form.nameOfPayee = nameOfPayee ?? ''
            this.form.accountOfPayee = accountOfPayee ?? ''
            this.form.bankOfPayee = bankOfPayee ?? ''
          })
          .catch(() => {
            this.$message.error('获取结算单详情失败')
          })
          .finally(() => {
            this.loading = false
            if (this.refresh) {
              this.$emit('update:refresh', false)
            }
          })
      }
    },
    // 认不认可
    async whetherRecognized(confirm) {
      const { settleObjType } = this.detail
      const { accountOfPayee, bankOfPayee, nameOfPayee } = this.form
      if (!accountOfPayee) {
        this.$message.warning('请输入收款单位账号')
        return
      }
      if (!bankOfPayee) {
        this.$message.warning('请输入收款单位开户银行名称')
        return
      }
      if (!nameOfPayee) {
        this.$message.warning('请输入收款单位名称')
        return
      }
      try {
        const companyName = GlobalConfig.getCompanyName() ?? '公司'
        const content = confirm
          ? '您确认此结算项目的结算费用与收款信息吗？'
          : `请与${companyName}线下沟通结算明细后，再发起不认可。
          操作不认可后，请与${companyName}沟通重新发起结算单确认。`
        const confirmText = confirm ? '认可' : '我已沟通，不认可结算单'
        await this.$confirm(content, '确认结算单', {
          confirmButtonText: confirmText,
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      const req = {
        accountOfPayee,
        bankOfPayee,
        confirm,
        id: this.investSid,
        nameOfPayee,
        settleObjType,
        baseId: this.$store.getters?.userInfo?.baseId ?? ''
      }
      try {
        if (confirm) {
          this.wReLoading = true
        } else {
          this.noReLoading = true
        }
        const res = await confirmSettlement(req)
        const { code, msg } = res?.data || {}
        if (code === 0) {
          this.$message.success('确认结算单操作成功')
          this.getDetail()
        } else {
          this.$message.error(msg ?? '确认结算单操作失败')
        }
      } catch (e) {
        this.$message.error('确认结算单操作失败')
      } finally {
        if (confirm) {
          this.wReLoading = false
        } else {
          this.noReLoading = false
        }
      }
    },
    // 确认收款
    async whetherConfirmReceivables() {
      try {
        await this.$confirm('您确定已收到此结算费用吗？', '确认收款', {
          confirmButtonText: '我已收款',
          cancelButtonText: '再次核实',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      const { settleObjType, accountOfPayee, bankOfPayee, nameOfPayee } = this.detail
      const req = {
        id: this.investSid,
        confirm: true,
        settleObjType,
        accountOfPayee,
        bankOfPayee,
        nameOfPayee,
        baseId: this.$store.getters?.userInfo?.baseId ?? ''
      }
      try {
        this.rvLoading = true
        const res = await confirmReceivables(req)
        const { code, msg } = res?.data || {}
        if (code === 0) {
          this.$message.success('确认收款单操作成功')
          this.getDetail()
        } else {
          this.$message.error(msg ?? '确认收款操作失败')
        }
      } catch (e) {
        this.$message.error('确认收款操作失败')
      } finally {
        this.rvLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ukp_procs_steps {
  ::v-deep .el-step.is-vertical {
    .el-step__head {
      @apply w-4;
      &.is-process {
        .el-step__line {
          @apply bg-theme;
        }
        .el-step__icon {
          @apply text-theme border-theme;
        }
      }
    }
    .el-step__line {
      width: 1px;
      top: 16px;
      left: 8px;
    }
    .el-step__icon {
      @apply w-4 h-4 bg-white text-ccc border border-solid border-ccc flex items-center justify-center;
      &.is-text {
        @apply border;
      }
      .el-step__icon-inner {
        @apply text-small font-normal;
      }
    }
    .el-step__title {
      @apply pb-0 pl-2 h-4 font-medium text-medium text-theme-black-850 flex items-center;
      line-height: 1;
      &.is-wait {
        @apply text-theme-black-450;
      }
    }
    .el-step__main {
      @apply pl-0 overflow-hidden;
    }

    .el-collapse-item__wrap {
      @apply border-b-0 overflow-visible;
    }
    .el-collapse-item__content {
      @apply pb-0;
    }
    .el-step__description {
      @apply ml-2.5 pr-0;
    }
  }
  ::v-deep .ukp_procs_coll {
    @apply border-0 py-3;
    .el-collapse-item__header {
      @apply hidden;
    }
  }
  ::v-deep .last_ukp_procs_coll {
    @apply border-0 py-0;
    .el-collapse-item__header {
      @apply hidden;
    }
  }
  .green-card {
    @apply text-theme-black-850;
    background-color: rgba($color: #00be6a, $alpha: 0.15);
  }
  .red-card {
    @apply text-danger;
    background-color: rgba($color: #e34152, $alpha: 0.15);
  }
}
</style>
